export const RDY_FOR_VALIDATION = "Import In Progress"; // state#1
export const VALIDATION_IN_PROGRESS = "Import In Progress"; //after  submitted to PDF
export const VALIDATION_COMPLETE = "Import In Progress";
export const VALIDATION_FAILED = "Import Failed";  // PDF returned invalid Json file. 
export const VALIDATION_ERROR = "Import Failed";  //PDF validated  Errors returned. 
export const RDY_FOR_IMPORT = "Import In Progress";//PDF  validated, and no errors and handover to PCX
export const IMPORT_FAILURE = "Import Failed";
export const IMPORT_SUCCESS = "Import Successful";
export const IMPORT_ERROR = "Import Failed";
export const IMPORT_RUNTIME_ERROR="Import Failed";
export const IMPORT_INVALID_FILE_ERROR="Import Failed";
export const IMPORT_FAIL_EXCEED_MAX_LIMIT="Import Failed";
export const IMPORT_BAD_REQUEST_ERROR="Import Failed";
export const IMPORT_IN_PROGRESS = "Import In Progress";
export const IMPORT_FAILED = "Import Failed";
export const IMPORT_SCHEMA_ERROR="Import Failed";
export const IMPORT_ACCESS_ERROR = "Import Failed";
export const IMPORT_SUCCESS_WARNING = "Import Successful";
export const IMPORT_SUCCESS_PARTIAL = "Import Partially Successful";
export const IMPORT_DATA_ERROR = "Import Failed";
export const FILE_TYPE_ERROR = "File should be xlsx";
export const FILE_SIZE_ERROR = "File size exceeded";
export const DUPLICATE_FILE_ERROR= "Duplicate file name";
export const READY_FOR_IMPORT_LABEL="Ready for Import";
export const SUCCESS="Success";

export const tfob = {
    contentType : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    uploadFilesMaxLimit : "10"
    
};